import AssignGroupModal from './AssignGroupModal.view';

export default AssignGroupModal;
